import { render, staticRenderFns } from "./DeviceSerialEdit.vue?vue&type=template&id=40dd58d6&scoped=true"
import script from "./DeviceSerialEdit.vue?vue&type=script&lang=js"
export * from "./DeviceSerialEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dd58d6",
  null
  
)

export default component.exports